export default __webpack_public_path__ + "static/media/delivery-box-operation-01.d4ce86d6.png";